import { API } from "../../../utils/api";

export const getReferences = async ({ query, pagination }) => {
  const { pageIndex, pageSize } = pagination;
  const res = await API.get(
    `references?page=${pageIndex}&per_page=${pageSize}`,
    query
  );
  return res.data.data;
};
